import user from './user';
import transaction from './transaction';
import journal from './journal';
import token from './token';
import api from './api';
import media from './media';
import identityDocumentValidation from './identityDocumentValidation';
import addressValidation from './addressValidation';

export default {
  api,
  user,
  transaction,
  journal,
  token,
  media,
  identityDocumentValidation,
  addressValidation,
};
